module.exports = __webpack_public_path__ + "wlasan.png?9d3ecc04264263ed46bf8ac06b33f549";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/wlasan.png
// module id = 160
// module chunks = 0